import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { FLEET_CACHE_KEY } from 'services/queryKeys';
import { Fleet } from 'types';

export const useGetFleet = (fleetId: string) => {
  const { data = {} as Fleet, ...rest } = useAxiosQuery<Fleet>(FLEET_CACHE_KEY(fleetId), `/fleets/${fleetId}/`, {
    enabled: !!fleetId,
  });

  return { fleet: data, ...rest };
};
